import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.59 10.59L2 12L8 6L2 -5.24537e-07L0.590001 1.41L5.17 6L0.59 10.59Z", fill: "#A1A1A1" }));
const ForwardRef = forwardRef(SvgChevron);
export default ForwardRef;
